import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3e41089e")

_pushScopeId("data-v-3e41089e")
const _hoisted_1 = { class: "tooltips" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "shopyy1 icon-Hint" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createVNode(_component_el_tooltip, {
      placement: _ctx.placement,
      style: { marginLeft: '8px' }
    }, {
      content: _withId(() => [
        (_ctx.$slots.content)
          ? _renderSlot(_ctx.$slots, "content", { key: 0 }, undefined, true)
          : (_openBlock(), _createBlock("div", {
              key: 1,
              class: "content-wrap",
              style: { maxWidth: _ctx.width + 'px' }
            }, _toDisplayString(_ctx.content), 5))
      ]),
      default: _withId(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["placement"])
  ]))
})